/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Box } from "@mui/material";
import * as Actions from "actions";

// Import Swiper styles
import 'swiper/swiper.min.css';
import "./ShopProductNewSlider.scss";

import ShopProductItem from "components/elements/user/products/ShopProductItem";

import MockProductBox from "components/elements/main/MockProductBox";
import {checkProductInCart, isFeatureSupported, isMarketPlace, isShopSiteAndSubdomain} from "helpers/utils";
import CustomSectionCreator from "components/CustomSectionCreator";
import StorageIcon from "@mui/icons-material/Storage";

const ShopProductPopularSlider = (props) => {
  const {
    products, addProductToCart, addProductToWishlist, addToCompare,
      userGetNewProducts, bootupInfo, isLoading, shopId,
      cartItems, cartAddingPid, isCartLoading, currency
  } = props;

  useEffect(() => {
      userGetNewProducts(shopId, true, !isMarketPlace());
  }, []);

    const breakpoints = {
        300: {
            slidesPerView: 2.0,
            spaceBetween: 20,
        },
        340: {
            slidesPerView: 2.2,
            spaceBetween: 20,
        },
        380: {
            slidesPerView: 2.4,
            spaceBetween: 20,
        },
        420: {
            slidesPerView: 2.6,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 2.8,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
    };

    const renderResults = () => (
        <Container>
            <CustomSectionCreator title={'Latest ' + process.env.REACT_APP_PRODUCT_TITLE} seeMoreLink={isShopSiteAndSubdomain() ?
                isFeatureSupported("shopreels") ? "/products/sort/new?loadstory=1" : "/products/sort/new"
                :
                isFeatureSupported("shopreels") ?`/shop/${shopId}/products/sort/new?loadstory=1` : "/shop/${shopId}/products/sort/new"}
                                  seeMoreLinkTitle={isFeatureSupported("shopreels") ? "View " + process.env.REACT_APP_REELS_TAG : "View more"} />
            <swiper-container slides-per-view="1.8" space-between="4" free-mode="true" breakpoints={JSON.stringify(breakpoints)}>
                    { products.map((product, index) => (
                        <swiper-slide key={index}>
                            <Box sx={{ width: 150 }}>
                            <ShopProductItem
                                product={product}
                                currency={currency}
                                inCart={checkProductInCart(cartItems, product.id)}
                                isCartLoading={isCartLoading}
                                cartAddingPid={cartAddingPid}
                                shopId={shopId}
                                onAddToCompareClicked={() => addToCompare(product)}
                                onAddToWishlistClicked={() => addProductToWishlist(product)}
                                onAddToCartClicked={() => addProductToCart(product._id, shopId, !isMarketPlace())}
                            />
                            </Box>
                        </swiper-slide>
                    ))}
                </swiper-container>
        </Container>
    );
  return (

      <>
          {isLoading ? <MockProductBox />
              : products.length > 0
                  ? renderResults()
                  : ""}

      </>
  );
};

ShopProductPopularSlider.defaultProps = {
};

ShopProductPopularSlider.propTypes = {
    currency: PropTypes.string,
  addProductToCart: PropTypes.func.isRequired,
  addProductToWishlist: PropTypes.func.isRequired,
  addToCompare: PropTypes.func.isRequired,
    userGetNewProducts: PropTypes.func.isRequired,
  bootupInfo: PropTypes.objectOf(PropTypes.any).isRequired,
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
};

// Mapping Props and State.
const shopProductPopularSlider = connect(
  ({ userproducts, cartList, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userproducts.reqStatus,
    isLoading: userproducts.isLoading,
    serviceError: userproducts.serviceError,
    products: userproducts.newproducts,
      cartItems: cartList.cart,
      isCartLoading: cartList.isLoading,
      cartAddingPid: cartList.cartAddingPid,
      currency: bootupInfo.currency,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopProductPopularSlider);

export { shopProductPopularSlider as default };
